import { TValueOfStringRecord } from '@interfaces/common/genericWithModifying';

export const EUserProfileFormValue = {
	firstName: 'firstName',
	lastName: 'lastName',
	avatarId: 'avatarId',
	jobTitle: 'jobTitle',
	phoneNumber: 'phoneNumber',
	is2FA: 'is2FA',
} as const;

export const ECode2FaForm = {
	code: 'code',
} as const;

export const Disable2FA = {
	password: 'password',
} as const;

export const EUserPasswordValues = {
	currentPassword: 'currentPassword',
	newPassword: 'newPassword',
	confirmPassword: 'confirmPassword',
} as const;

export type TUserProfileFormValue = TValueOfStringRecord<typeof EUserProfileFormValue>
export type TCode2FaForm = TValueOfStringRecord<typeof ECode2FaForm>
export type TDisable2FA = TValueOfStringRecord<typeof Disable2FA>
export type TUserPasswordValues = TValueOfStringRecord<typeof EUserPasswordValues>

